import React from 'react';

const VideoOne = () => {
  return (
    <section className="video-one">
      <div className="video-one__bg-1" style={{ backgroundImage: 'url(assets/images/23.jpg)' }}></div>
      <div className="video-one__bg-2" style={{ backgroundImage: 'url(assets/images/6.jpg)' }}></div>
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-3">
            <div className="video-one__donate">
              <div className="video-one__donate-icon"><span className="icon-kindness"></span></div>
              <p className="video-one__donate-text">Your support powers education, healthcare and relief.</p>
              <h3 className="video-one__donate-title">Make your Donation<br /> Now</h3>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="video-one__inner">
              <div className="video-one__inner-bg" style={{ backgroundImage: 'url(assets/images/26.webp)' }}></div>
              <div className="video-one__video-link">
                <a href="https://www.youtube.com/watch?v=Get7rqXYrbQ" className="video-popup">
                  <div className="video-one__video-icon">
                    <span className="icon-play-button-arrowhead"></span>
                    <i className="ripple"></i>
                  </div>
                </a>
              </div>
              <p className="video-one__sub-title">Learn how your giving creates impact</p>
              <h2 className="video-one__title">Together we change lives</h2>
              <p className="video-one__text">Join Rayyan Aid to deliver dignity through education, healthcare, nutrition and relief.</p>
              <div className="video-one__btn-box">
                <a href="/about" className="thm-btn">
                  <span className="thm-btn-text">Donate Now</span>
                  <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3">
            <div className="video-one__donate video-one__donate-2">
              <div className="video-one__donate-icon"><span className="icon-user-1"></span></div>
              <p className="video-one__donate-text">Every donation is tracked to real outcomes.</p>
              <h3 className="video-one__donate-title">Your donation changes lives</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoOne;
